import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  container: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'whitesmoke',
    padding: 0,
    margin: 0,
    color: 'dimgray',
    cursor: 'pointer',
    fontSize: '0.9em',
    transition: 'all 100ms ease-in-out'
  },
  day: {
    appearance: 'none',
    position: 'relative',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'transparent',
    border: 0,
    margin: 0,
    padding: 0,
    color: 'inherit',
    font: 'inherit',
    lineHeight: 'normal',
    cursor: 'inherit',
    overflow: 'visible',
    ':active': {
      outline: 0
    }
  },
  isOutsideDay: {
    border: 0,
    cursor: 'default',
    ':active': {
      backgroundColor: 'white'
    }
  },
  blocked: {
    color: 'lightgrey',
    backgroundColor: 'white',
    borderColor: 'whitesmoke',
    cursor: 'default',
    ':active': {
      backgroundColor: 'white'
    }
  },
  blockedCalendar: {
    backgroundColor: 'whitesmoke',
    color: 'lightgrey',
    cursor: 'default',
    ':active': {
      backgroundColor: 'whitesmoke'
    }
  },
  blockedOutOfRange: {
    backgroundColor: 'white',
    color: 'lightgray',
    borderColor: 'whitesmoke',
    cursor: 'default',
    ':active': {
      backgroundColor: 'white'
    }
  },
  valid: {},
  hovered: {
    backgroundColor: 'whitesmoke',
    borderColor: 'whitesmoke',
    borderStyle: 'double'
  },
  afterHoveredStart: {
    backgroundColor: 'paleturquoise',
    borderStyle: 'double',
    borderColor: 'paleturquoise',
    color: 'white',
    ':active': {
      backgroundColor: 'paleturquoise'
    }
  },
  hoveredSpan: {
    backgroundColor: 'paleturquoise',
    borderStyle: 'double',
    borderColor: 'paleturquoise',
    color: 'white',
    ':active': {
      backgroundColor: 'paleturquoise'
    }
  },
  highlightedCalendar: {
    borderStyle: 'double',
    borderColor: 'crimson',
    color: 'dimgray',
    cursor: 'default',
    ':active': {
      borderColor: 'crimson'
    }
  },
  today: {
    borderStyle: 'double',
    borderColor: 'darkturquoise'
  },
  lastInRange: {
    borderRightColor: 'paleturquoise'
  },
  blockedMinimumNights: {
    backgroundColor: 'paleturquoise',
    color: 'white',
    borderColor: 'paleturquoise',
    cursor: 'default',
    ':active': {
      backgroundColor: 'paleturquoise'
    }
  },
  selectedSpan: {
    backgroundColor: 'turquoise',
    borderStyle: 'double',
    borderColor: 'turquoise',
    color: 'white',
    ':active': {
      backgroundColor: 'paleturquoise'
    }
  },
  selected: {
    backgroundColor: 'darkturquoise',
    borderStyle: 'double',
    borderColor: 'darkturquoise',
    color: 'white',
    ':active': {
      backgroundColor: 'darkturquoise'
    }
  },
  selectedStart: {
    backgroundColor: 'darkturquoise',
    borderStyle: 'double',
    borderColor: 'darkturquoise',
    color: 'white',
    ':active': {
      backgroundColor: 'darkturquoise'
    }
  },
  selectedEnd: {
    backgroundColor: 'darkturquoise',
    borderStyle: 'double',
    borderColor: 'darkturquoise',
    color: 'white',
    ':active': {
      backgroundColor: 'darkturquoise'
    }
  }
});